export default "__VITE_ASSET__BKLmMTxm__"